/* eslint-disable */


import Vue from 'vue';
import App from './App';
import router from './router';
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import qs from 'qs';
import "babel-polyfill"
import Cookies from 'js-cookie';
import NProgress  from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/common/store/';
import i18n from './i18n/i18n'
import { axios, urls } from '@/common/index';
import './libs/gt4.js';




import 'swiper/dist/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css'
import '@/common/rem/rem.js'
import '@/common/style/base.css'
import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards);
Vue.use(AlertPlugin,{position: 'middle'})


NProgress.configure({
easing: 'ease',  // 动画方式
speed: 500,  // 递增进度条的速度
showSpinner: false, // 是否显示加载ico
trickleSpeed: 200, // 自动递增间隔
minimum: 0.3 
})



Vue.config.productionTip = false;

Vue.prototype.$Cookies = Cookies;

Vue.prototype.$project = '821';
Vue.prototype.$api = axios;
Vue.prototype.$urls = urls;







import { switchCase, toFixed, strEncryption, moneyFilter } from '@/common/filter/index.js'
import { parseTime } from '@/common/utils/Date.js'
Vue.filter("switchCase", switchCase)
Vue.filter("ToFixed", toFixed)
Vue.filter("strEncryption", strEncryption)
Vue.filter("parseTime", parseTime)
Vue.filter("moneyFilter", moneyFilter)



import GL_Component from "./utils/globalComponent.js"
Vue.use(GL_Component);


import GL_ui from "./utils/global-ui.js"
Vue.use(GL_ui)

import limitNum from '@/common/directive/onlyNum'
Vue.directive('limitNum', limitNum)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
i18n,
components: { App },
template: '<App/>',
});

console.log(window.location.href)

router.beforeEach((to, from, next) => {

NProgress.start();
if (to.path) {
if (window._hmt) {
window._hmt.push(['_trackPageview', '/#' + to.fullPath])
}
}
next()
})

router.afterEach(() => {

NProgress.done()
})



// WEBPACK FOOTER //
// ./src/pages/build821/build821.js